<div
  class="portlet light"
  *ngIf="!isTeamsData && !isNewsDetail && !isAdminOrganizationDetail && !userInfoFromOrgMemberShip"
>
  <div class="portlet-title">
    <div class="caption">
      <span class="bootstrap-dialog-title">User profile details</span>
    </div>
  </div>
</div>
<div class="portlet-body" *ngIf="!isTeamsData && !isNewsDetail && !isAdminOrganizationDetail">
  <div class="table-responsive details-table w-100">
    <div class="d-flex float-end pb-3" *ngIf="isShowEditButton">
      <button class="btnText" (click)="editUser()">Edit user</button>
    </div>
    <table class="table table-striped table-bordered table-hover">
      <tbody>
        <tr>
          <th>Email</th>
          <td>{{ data?.userName || noValueText }}</td>
        </tr>
        <tr>
          <th>First name</th>
          <td>{{ data?.firstName || noValueText }}</td>
        </tr>
        <tr>
          <th>Last name</th>
          <td>{{ data?.lastName || noValueText }}</td>
        </tr>
        <tr>
          <th>Phone</th>
          <td>{{ data?.phone || noValueText }}</td>
        </tr>
        <tr>
          <th>Post code</th>
          <td>{{ data?.postCode || noValueText }}</td>
        </tr>
        <tr>
          <th>Country</th>
          <td>{{ data?.countryName || noValueText }}</td>
        </tr>
        <tr>
          <th>State</th>
          <td>{{ data?.stateName || noValueText }}</td>
        </tr>
        <tr>
          <th>Address</th>
          <td>{{ data?.address || noValueText }}</td>
        </tr>
        <tr>
          <th>Created on</th>
          <td>{{ data?.createdOn | date : 'dd/MM/YYYY' || noValueText }}</td>
        </tr>
        <tr>
          <th>Active</th>
          <td>{{ data?.isActive ? 'Yes' : data?.isActive == false ? 'No' : '' }}</td>
        </tr>
        <tr>
          <th>Last login</th>
          <td>
            {{ data?.lastLogin ? (data?.lastLogin | date : 'dd/MM/YYYY') : 'Not yet logged in' }}
          </td>
        </tr>
        <tr *ngIf="!userInfoFromOrgMemberShip">
          <th>Change password on next login</th>
          <td>
            <input
              type="checkbox"
              class="chkOverview"
              [(ngModel)]="isChecked"
              (change)="changePassword($event)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="portlet light" *ngIf="isNewsDetail || isTeamsData">
  <div class="portlet-title">
    <div class="caption">
      <span *ngIf="isTeamsData" class="bootstrap-dialog-title">Team profile details</span>
      <span *ngIf="isNewsDetail" class="bootstrap-dialog-title">News details</span>
    </div>
  </div>
</div>
<div class="portlet-body" *ngIf="isTeamsData && !isNewsDetail">
  <div class="table-responsive details-table w-100">
    <table class="table table-striped table-bordered table-hover">
      <tbody>
        <tr>
          <th>Team name</th>
          <td>{{ teamsData?.name }}</td>
        </tr>
        <tr>
          <th>Organization</th>
          <td>{{ teamsData?.organizationName }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="portlet-body" *ngIf="isNewsDetail && !isTeamsData">
  <div class="table-responsive details-table w-100">
    <table class="table table-striped table-bordered table-hover">
      <tbody>
        <tr>
          <th>Date</th>
          <td>{{ newsDetails?.date }}</td>
        </tr>
        <tr>
          <th>Subject</th>
          <td>{{ newsDetails?.subject }}</td>
        </tr>
        <tr>
          <th>Description</th>
          <td [innerHTML]="newsDetails?.description"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="portlet light" *ngIf="isAdminOrganizationDetail">
  <div class="portlet-title">
    <div class="caption">
      <span class="bootstrap-dialog-title">Organization details</span>
    </div>
  </div>
</div>
<div class="portlet-body" *ngIf="!isNewsDetail && !isTeamsData && isAdminOrganizationDetail">
  <div class="table-responsive details-table main-status-dropdown w-100">
    <div class="d-flex float-end pb-3">
      <button class="btnText" (click)="editOrg()">Edit organization</button>
    </div>
    <div class="d-flex float-end pb-3" *ngIf="isRoleSuperAdmin">
      <button class="btnText addUserBtn" (click)="addUser(0, 'Add new user')">Add user</button>
    </div>
    <table class="table table-striped table-bordered table-hover">
      <tbody>
        <tr>
          <th>Organization name</th>
          <td>{{ adminOrganizationData?.name }}</td>
        </tr>
        <tr>
          <th>Start date</th>
          <td>{{ adminOrganizationData?.startDate }}</td>
        </tr>
        <tr>
          <th>Expiry date</th>
          <td>{{ adminOrganizationData?.expDate }}</td>
        </tr>
        <tr>
          <th>Total users limit</th>
          <td>{{ adminOrganizationData?.totalUsers }}</td>
        </tr>
        <tr>
          <th>Total users allocated</th>
          <td>{{ adminOrganizationData?.totalUsersAllocated }}</td>
        </tr>
        <tr>
          <th>Terms & condition status</th>
          <td>
            <div class="mainStatus">
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                #package
                [items]="statusList"
                bindLabel="name"
                [searchable]="false"
                [searchFn]="commonInputSearch"
                placeholder="Status"
                [(ngModel)]="selectedStatus"
                class="accordion-text addScroll statusContentStatusDrp"
                (change)="onChangeStatus($event)"
                [readonly]="isShowUpload"
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div class="contentStatusInput" *ngIf="!isShowUpload">
                <div class="">
                  <textarea
                    maxlength="200"
                    [disabled]="selectedStatus?.id != 4"
                    (blur)="onBlurComment()"
                    placeholder="Comment"
                    [(ngModel)]="statusComment"
                    rows="1"
                  ></textarea>
                </div>
              </div>
              <div class="contentStatusInput" *ngIf="isShowUpload">
                <div>
                  <div class="fileinput fileinput-new">
                    <div class="input-group input-large">
                      <div
                        class="form-control uneditable-input d-flex justify-content-flex-start align-items-center text-decoration-underline"
                        data-trigger="fileinput"
                      >
                        <i class="fa fa-file fileinput-exists" *ngIf="isShowChangeTC"></i>
                        <span *ngIf="!!selectedFilesTC" class="fileinput-filename"
                          >&nbsp; {{ selectedFilesTC }}</span
                        >
                        <span *ngIf="!selectedFilesTC" class="fileinput-filename"
                          ><label class="input-center">Upload file</label></span
                        >
                      </div>
                      <span class="btn default btn-file">
                        <input
                          type="file"
                          #myFileInput
                          accept="application/pdf"
                          (change)="fileChangeEvent($event)"
                          style="display: none"
                          #hiddenfileinput
                        />
                        <button
                          style="
                            padding: 0px;
                            color: white;
                            width: 140px !important;
                            border-radius: 0px;
                          "
                          (click)="hiddenfileinput.click()"
                          class="waves-effect waves-light btn"
                          *ngIf="!isShowChangeTC || extFileTC"
                        >
                          Select file
                        </button>
                        <button
                          style="padding: 0px; color: white; width: 100px !important"
                          *ngIf="isShowChangeTC && !extFileTC"
                          (click)="hiddenfileinput.click()"
                          class="waves-effect waves-light btn"
                        >
                          Change
                        </button>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="extFileTC">
                    <span id="PiqetValidationSummary" class="input-error"
                      >Invalid file type: Only PDF files are allowed</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="!isShowUpload">
          <th>Document</th>
          <td>
            <piqet-angular-verification-button-renderer
              [docPath]="adminOrganizationData?.docPath"
            ></piqet-angular-verification-button-renderer>
          </td>
        </tr>
        <tr>
          <th>License level</th>
          <td>
            <div class="mainStatus">
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                #license
                [items]="licenseLevelList"
                bindLabel="name"
                [searchable]="false"
                [searchFn]="commonInputSearch"
                placeholder="License level"
                [formControl]="licenseControl"
                class="accordion-text addScroll licenseContentStatusDrp"
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div class="contentStatusInput" *ngIf="licenseUpdatedBy === checkLicenseUpdateById">
                <div class="modal-footer">
                  <button
                    type="button"
                    class="modelBtn purpleBtnHoverEffect"
                    (click)="resetLicenseLevel()"
                  >
                    Reset level
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>Source</th>
          <td class="ag-cell-value">
            {{ sourceType }}
            <div *ngIf="isShowCommentBox" class="source-comment">
              <span class="source-comment-label">Specified as :</span> {{ commentText }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
